import { coreRoles } from "@/constants/coreRoles.ts";
import { Checkbox, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const CoreRolesCheckboxes = () => {
    const { watch, setValue, formState } = useFormContext();
    const selectedRoles = watch("coreRoles") || [];
    const error = useMemo(() => {
        return formState.errors.coreRoles;
    }, [formState.errors]);

    const handleCheckboxChange = (role: string) => {
        let updatedRoles = selectedRoles.includes(role)
            ? selectedRoles.filter((r: string) => r !== role)
            : [...selectedRoles, role];

        if (role === "AllRoles" && !selectedRoles.includes("AllRoles")) {
            setValue("coreRoles", ["AllRoles"]);
            return;
        }

        if (role === "AllRoles" && selectedRoles.includes("AllRoles")) {
            updatedRoles = coreRoles.filter((r) => r.id !== "AllRoles").map((r) => r.id);
            setValue("coreRoles", updatedRoles);
            return;
        }

        setValue("coreRoles", updatedRoles);
    };

    const allRolesSelected = useMemo(() => {
        return selectedRoles.includes("AllRoles");
    }, [selectedRoles]);

    return (
        <Box sx={{ display: "flex" }}>
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                <FormLabel component="legend">Core Roles</FormLabel>
                <FormGroup>
                    {coreRoles.map((role) => (
                        <FormControlLabel
                            key={role.id}
                            control={
                                <Checkbox
                                    name={`coreRoles[${role.label}]`}
                                    checked={selectedRoles.includes(role.id) || allRolesSelected}
                                    onChange={() => handleCheckboxChange(role.id)}
                                    disabled={allRolesSelected && role.id !== "AllRoles"}
                                />
                            }
                            label={role.label}
                        />
                    ))}
                    {error && <Typography color="error">{error.message?.toString()}</Typography>}
                </FormGroup>
            </FormControl>
        </Box>
    );
};

export default CoreRolesCheckboxes;
